export class GameConstants {

    public static readonly VERSION = "0.0";
    public static readonly DEVELOPMENT = false;
    public static readonly DEBUG_MODE = false;
    public static readonly VERBOSE = false;

    public static readonly GAME_WIDTH = 1000;
    public static readonly GAME_HEIGHT = 800;
    
    public static readonly BOT = "bot";
    public static readonly PLAYER = "player";

    public static readonly PLAYER_1 = "player 1";
    public static readonly PLAYER_2 = "player 2";

    public static readonly VS_PLAYER = "vs player";
    public static readonly VS_AI = "vs ai";

    public static readonly LANGUAGE_EN = "en";
    public static readonly LANGUAGE_BR = "br";
    public static readonly LANGUAGE_DE = "de";
    public static readonly LANGUAGE_ES = "es";
    public static readonly LANGUAGE_FR = "fr";
    public static readonly LANGUAGE_IT = "it";
    public static readonly LANGUAGE_RU = "ru";

    public static readonly LANGUAGES = [
        GameConstants.LANGUAGE_BR,
        GameConstants.LANGUAGE_DE,
        GameConstants.LANGUAGE_ES,
        GameConstants.LANGUAGE_EN,
        GameConstants.LANGUAGE_FR,
        GameConstants.LANGUAGE_IT,
        GameConstants.LANGUAGE_RU
    ];

    public static readonly BOARD_ELEMENTS: {in: number, out: number, id: number, anims?: number[]} [] = [

        // ESCALERAS
        {in: 4, out: 14, id: 1, anims: [0]},
        {in: 8, out: 32, id: 2, anims: [1]},
        {in: 20, out: 38, id: 3, anims: [2]},
        {in: 28, out: 84, id: 4, anims: [3, 4]},
        {in: 40, out: 59, id: 5, anims: [5]},
        {in: 58, out: 83, id: 6, anims: [6]},
        {in: 72, out: 93, id: 7, anims: [7]},
        
        // serpientes
        {in: 15, out: 3, id: 5},
        {in: 31, out: 9, id: 8},
        {in: 44, out: 26, id: 2},
        {in: 62, out: 19, id: 3},
        {in: 74, out: 70, id: 7},
        {in: 85, out: 33, id: 4},
        {in: 91, out: 71, id: 6},
        {in: 98, out: 80, id: 1}
    ];

    public static readonly SAVED_GAME_DATA_KEY = "snake-and-ladders-data";
}
